import { cartService } from "services/cart.service"
import { offerService } from "services/offer.service"
import { isUUID } from "external/lodash"

const hooks =  [
]

export {hooks as default}

export async function fetchOffersSummary({update, state}) {
    const {offersSummaryList: {initialized}} = state
    if (initialized) return
    update({offersSummaryList: {$startLoading: {}}})
    const summary = await offerService.getOffersSummary()
    update({ offersSummaryList: {$updateLoadableList: summary.data.data}})
}

export async function fetchCart({update, state}, {contexts}) {
    const {id: client} = contexts.Auth.state.user || {}
    const {id} = state.cart
    let cart = undefined
    if (client) {
        cart = await cartService.client(client, id) 
        if (cart.data === false) {
            cart = await cartService.anonymous(id)
            if (cart.data) {
                const {basic = [], elective = []} = cart.data.properties
                const isNotEmpty = basic.concat(elective).filter((id) => id !== false).length > 0
                // Take ownership if the cart is not empty
                if (isNotEmpty) {
                    cart = await cartService.saveCart({...cart.data, client})
                } else {
                    cart.data = false
                }
            }
        }
        if (cart.data === false) {
            cart = await cartService.client(client) 
        }
        if (cart.data === false) {
            cart = await cartService.create(client)
        }
    } else {
       cart = await cartService.anonymous(isUUID(id) ? id : undefined) 
    }
    if (cart.data) {
        const properties = cart.data.properties
        if (!properties.basic) properties.basic = Array(5).fill(false)
        if (!properties.basicExtra) properties.basicExtra = Array(5).fill(false)
        if (!properties.elective) properties.elective = Array(3).fill(false)
        if (!properties.electiveExtra) properties.electiveExtra = Array(3).fill(false)
        if (!properties.workbooks)  properties.workbooks = {}
        localStorage.setItem('cartId', cart.data.id)
        update({cart: {id: {$set: cart.data.id}, client: {$set: cart.data.client}, properties: {$set: properties}}})
    }
}